
import {Servico} from '@/soganhei'

import http from '@/http/service'

export default function SalvarServico(payload=Servico){
 
    if(payload.idServico == undefined){
        return http.post("/admin/servicos",payload)
    }else{
        return http.put(`/admin/servicos/${payload.idServico}`,payload)
    }

}